/* template */
<template minapp="mpx" xlang="wxml"><from-item :isShow="(isShow)" :isRequired="(isRequired)" :isRequiredShow="(isRequiredShow)" label="性别" :isDisable="(isSexDisable)" :innerValue="(showValue)"><div slot="input" class="es-content__gender"><mpx-view @tap="selectGender('M')" class="gender-item"><radio-circle :size="(18)" :checked="(innerValue == 'M')"/><span class="gender-text">男</span></mpx-view><mpx-view @tap="selectGender('F')" class="gender-item"><radio-circle :size="(18)" :checked="(innerValue == 'F')"/><span class="gender-text">女</span></mpx-view></div></from-item></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m3ff66779"}'>
  +b('content')
    +e('gender')
      display flex
      align-items center
      color #333333
      .gender-item
        margin-right 24px
        display flex
        align-items center
      .gender-text
        margin-left 8px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3ff66779"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./contact-sex.mpx.js?isComponent&outputPath=components%2Fcontact-sex3ff66779%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./contact-sex.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcontact-sex3ff66779%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m3ff66779"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/contact-sex3ff66779/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'from-item':getComponent(require("./from-item.mpx?isComponent&outputPath=components%2Ffrom-item141a5554%2Findex")),'radio-circle':getComponent(require("../../radio-circle/index.mpx?isComponent&outputPath=components%2Findex17a49170%2Findex")),'es-cell':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/cell/index.mpx?isComponent&outputPath=components%2Findex1902b88c%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
